import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const lessThanOrEqualTo = (lessThanOrEqualControl: AbstractControl): ValidatorFn => {
  const key = 'lessThanOrEqualTo';
  let subscribe = false;

  return (control: AbstractControl): ValidationErrors | null => {
    if (!subscribe) {
      subscribe = true;
      lessThanOrEqualControl.valueChanges.subscribe(() => {
        control.updateValueAndValidity();
      });
    }

    const value = control.value;

    if (!value) return null;

    if (lessThanOrEqualControl.value < value) return { [key]: true };

    return null;
  };
}
